import {useCallback} from "react";
import {rxToggleNetworkErrorModal} from "../slices/appSlice";
import {useDispatch} from "react-redux";

const useNetwork = () => {
  const dispatch = useDispatch();

  const handleNetworkError = useCallback((error, actionPerStatusCode = {}) => {
    let handled = false;

    Object.keys(actionPerStatusCode).forEach(statusCode => {
      if ( +error?.response?.status === +statusCode) {
        actionPerStatusCode[statusCode](error);

        handled = true;
      }
    });

    if (!handled) {
      dispatch(rxToggleNetworkErrorModal({
        message: error.message || "",
        data: error.response?.data || {}
      }));

      if (process.env.NODE_ENV !== "production") {
        console.error(error);
      }
    }
  }, [dispatch]);

  return {handleNetworkError}
};

export default useNetwork;
